import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { Permission } from './PermissionsResponse.types.tsx';
import { fetchPermissions } from './fetchPermissions.tsx';

type PermissionMismatch = {
	projectId: number;
	permission: Permission['key'];
	bulk: boolean;
	legacy: boolean;
};

// TODO: remove this once jpd_multi-project-permission-fetch is stable
export const comparePermissionsWithLegacy = async (
	projectIds: number[],
	bulkPermissionsByProjectId: Record<string, Permission[]>,
): Promise<void> => {
	try {
		const legacyPermissionsByProject = await Promise.all(
			projectIds.map((projectId) => fetchPermissions(projectId)),
		);
		const mismatches: PermissionMismatch[] = [];

		projectIds.forEach((projectId, index) => {
			const legacyPermissions = legacyPermissionsByProject[index] ?? [];
			const bulkPermissions = bulkPermissionsByProjectId[String(projectId)] ?? [];

			for (const bulkPermission of bulkPermissions) {
				const legacyPermission =
					legacyPermissions.find(({ key }) => key === bulkPermission.key)?.havePermission ?? false;

				if (bulkPermission.havePermission !== legacyPermission) {
					mismatches.push({
						projectId,
						permission: bulkPermission.key,
						bulk: bulkPermission.havePermission,
						legacy: legacyPermission,
					});
				}
			}
		});

		if (mismatches.length > 0) {
			await log.safeWarnWithoutCustomerData(
				'polaris.component-permissions-store.fetchPermissionsForProjects',
				'bulk and legacy permissions differ',
				{ mismatches: JSON.stringify(mismatches) },
			);
		}
	} catch {
		// This diagnostic comparison must not affect permission loading.
	}
};
